const s = {
  isXS: !1,
  isSM: !1,
  isMD: !1,
  isLG: !1,
  isXL: !1,
  is2XL: !1
};
export {
  s as defaultBreakpoints
};
